import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http'
import { inject } from '@angular/core'
import { finalize, tap } from 'rxjs'
import { environment } from '../../../environments/environment'
import { ActivityTrackerService } from '../activity/activity-tracker.service'
import { requestKind } from '../activity/activity-route-kind'

/**
 * activityInterceptor — feeds Editor Activity Tracking with request counts, wait
 * time, slow and failed requests. Registered after `authInterceptor`. A pass-through
 * while the tracker is inactive; requests outside `environment.apiUrl` and
 * cancellations (no response, no error) are ignored.
 */
export const activityInterceptor: HttpInterceptorFn = (req, next) => {
  const tracker = inject(ActivityTrackerService)
  if (!tracker.isActive) return next(req)
  const kind = requestKind(req.method, req.url, environment.apiUrl)
  if (!kind) return next(req)
  const start = tracker.mono()
  let status: number | null = null
  let end = 0
  return next(req).pipe(
    tap({
      next: ev => { if (ev instanceof HttpResponse) { status = ev.status; end = tracker.mono() } },
      error: err => { status = err instanceof HttpErrorResponse ? err.status : 0; end = tracker.mono() },
    }),
    finalize(() => { if (status !== null) tracker.recordRequest(kind, end - start, status) }),
  )
}
